import { createI18n } from 'vue-i18n';
import { en } from './locales/en';

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages: {
    en,
  },
  // Doesnt work :(
  // pluralizationRules: {
  //   en: (choice) => {
  //     if (choice === 0) {
  //       return 0; // `No likes`
  //     }
  //     if (choice === 1) {
  //       return 1; // Singular
  //     }
  //     return 2; // Plural
  //   },
  // },
});
